import React from 'react';
import { Button, styled } from '@mui/material';
import theme from '../../constants/theme';

export const FilledButtonStyled = styled(Button)({
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.primary.main,
  borderRadius: 'unset',
  fontSize: theme.typography.h5.fontSize,
  textTransform: 'initial',
  height: '40px',
  padding: '8px 16px',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: `${theme.palette.secondary.main} !important`,
  },
});
